export const GTM_PLATFORM = '3mp' as const

/**
 * GA4 content group for CMS marketing routes. GTM's GA4 configuration tag reads `content_group`
 * from the dataLayer on Initialization, so it is pushed before GTM loads (`CmsContentGroupScript`).
 */
export const GTM_CMS_CONTENT_GROUP = '3MP' as const
